/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_1_B3Inputs */

const en_mk_agent_1_b3 = /** @type {(inputs: Mk_Agent_1_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel, re-run or ask for a revision at any point`)
};

const id_mk_agent_1_b3 = /** @type {(inputs: Mk_Agent_1_B3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dibatalkan, diulang, atau diminta revisi kapan saja`)
};

/**
* | output |
* | --- |
* | "Cancel, re-run or ask for a revision at any point" |
*
* @param {Mk_Agent_1_B3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_1_b3 = /** @type {((inputs?: Mk_Agent_1_B3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_1_B3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_1_b3(inputs)
	return en_mk_agent_1_b3(inputs)
});